module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/LTE#1-0a8324ccf559a5b3246f7eaa04d49fb7.svg";